<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 82 100">
    <defs>
      <path id="a" d="M0 0h81.913v100H0z" />
    </defs>
    <g :fill="iconColor" fill-rule="evenodd">
      <path
        fill="#B6E7F1"
        d="M44.155 62.377v-3.784h14.483v3.784h-5.085v12.981h-4.338V62.377h-5.06zm-17.086-3.784h5.06l2.989 4.31 3.012-4.31h4.988l-5.494 7.736 6.458 9.03h-5.084l-3.952-5.581-3.928 5.58h-5.013l6.459-9.005-5.495-7.76zm44.138 34.889H16.07c-2.287 0-4.148-1.85-4.148-4.125v-4.77h51.401c2.383 0 4.315-1.918 4.315-4.288v-26.01c0-2.37-1.932-4.29-4.315-4.29H11.922V10.644c0-2.269 1.861-4.119 4.148-4.119l37.957-.04V20.43c0 4.073 3.325 7.38 7.426 7.38l13.744-.039.154 61.586c0 2.275-1.857 4.125-4.144 4.125zm-60.139-34.89h14.483v3.785h-5.084v12.981h-4.338V62.377h-5.06v-3.784zM56.48 0H16.07C10.166 0 5.36 4.779 5.36 10.643V50H4.316C1.932 50 0 51.92 0 54.289v26.01c0 2.37 1.932 4.288 4.315 4.288h1.046v4.77C5.36 95.227 10.166 100 16.07 100h55.137c5.901 0 10.707-4.773 10.707-10.643V25.19L56.48 0z"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-txt',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
